import React, { Component } from "react";
import { Modal, Form, Row, Col, Button } from "antd";
import InputForm from "./InputForm";
import axios from 'axios';
import "./Form.css";
import CtaCorrenteFrame from './CtaCorrenteFrame';

const { Item: ItemForm } = Form;

export default class TipoDocForm extends Component {
  state = {
    registro: {
      td_codigo: '',
      td_descricao: '',
      td_cta_corrente: { key: '' }
    },
  };


  componentDidUpdate(propsAnterior, stateAnterior) {
    if (this.props.registroSelecionado !== propsAnterior.registroSelecionado) {
      this.setState({
        registro: this.props.registroSelecionado.data,
        td_cta_corrente: this.props.registroSelecionado.data.td_cta_corrente,
        visualizar: this.props.registroSelecionado.visualizar,
      }, () => {
        this.refs.td_codigo.focus();
      });
    }
  }

  onChange = event => {
    const value = event.target.value;
    const id = event.target.id;

    const { registro } = this.state;
    registro[id] = value;

    this.setState({
      [id]: value
    });
  };

  onChangeCtaCorrente = event => {
    const { registro } = this.state;
    registro['td_cta_corrente'] = event.td_cta_corrente;
    this.setState(event);
  }


  onOK = () => {
    if ((!this.state.registro.td_descricao) || (this.state.registro.td_descricao === '')) {
      Modal.warning({ title: 'Aviso!', content: 'Informe a Descrição' });
      return;
    }
    this.state.registro.td_cta_corrente = this.state.registro.td_cta_corrente && this.state.registro.td_cta_corrente.key ? String(this.state.registro.td_cta_corrente.key) : null;
    this.props.onSalvarClick(this.state.registro);
  };



  render() {
    const { onCancelarClick, carregando, visivel } = this.props;
    const { td_idf, td_codigo, td_descricao, td_cta_corrente } = this.state.registro;

    // console.log('TipoDocForm: ', this.state);

    return (
      <Modal
        title={td_idf ? "Edição de Tipo de Documento" : "Cadastro de Tipo de Documento"}
        visible={visivel}
        destroyOnClose
        onCancel={onCancelarClick}
        footer={null}
        width={"50%"}
        style={{ top: 30 }}
      >
        <Form>
          <Row>
            <Col xs={24} sm={4} className="camposEspacoDireita">
              <span>Código</span>
              <InputForm
                id="td_codigo"
                ref="td_codigo"
                onChange={this.onChange}
                value={td_codigo}
                validator={value => Boolean(value)}
                disabled={true}
              />
            </Col>

            <Col xs={24} sm={20}>
              <span>Descrição *</span>
              <InputForm
                id="td_descricao"
                ref="td_descricao"
                maxLength={30}
                onChange={this.onChange}
                value={td_descricao}
                validator={value => Boolean(value)}
                errorMessage="Informe a descrição"
              />
            </Col>

            <Col xs={24} sm={24} style={{ marginTop: -20 }}>
              <CtaCorrenteFrame
                label="Conta Corrente"
                id="td_cta_corrente"
                value={td_cta_corrente}
                width={"100%"}
                onChange={this.onChangeCtaCorrente}
                descricaoPrimeiroItem="Nenhuma Conta Corrente Informada"
              />
            </Col>

          </Row>
          <ItemForm>
            <Row>
              <Col xs={24}>
                {this.state.visualizar ? null : (
                  <Button
                    type="primary"
                    htmlType="button"
                    loading={carregando}
                    onClick={this.onOK}
                    className="btn-salvar"
                  >
                    Salvar
                  </Button>
                )}

                <Button
                  htmlType="button"
                  onClick={onCancelarClick}
                  className="btn-fechar"
                >
                  Fechar
                </Button>
              </Col>
            </Row>
          </ItemForm>

        </Form>
      </Modal>
    );
  }
}



// WEBPACK FOOTER //
// ./src/components/TipoDocForm.js